import React from 'react';
import { Layout } from '../components/Layout';
import { AutomationCenter } from '../components/automations';

const Automations = () => {
  return (
    <Layout>
      <AutomationCenter />
    </Layout>
  );
};

export default Automations;
